<app-cargando *ngIf="cargando"></app-cargando>

<div class="row">
    <div class="col-12">
        <div class="card">
            
            <div class="card-header">
                <h3 class="card-title">{{titulo}}</h3>
            </div>

            <!-- Barra de búsqueda -->
            <div class="card-body pb-0">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <div class="input-group">
                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                            <input type="text" class="form-control" placeholder="Buscar..." [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)">
                        </div>
                    </div>
                    <div class="col-md-8 d-flex align-items-center justify-content-end">
                        <small class="text-muted" *ngIf="totalCount > 0">{{totalCount}} registros encontrados</small>
                    </div>
                </div>
            </div>

            <div class="card-body pt-0">
                <div class="row">
                    <div class="columns col-12">
                        <ngx-table #table [configuration]="configuration" [data]="data" [columns]="columns"></ngx-table>
                        <ng-template #frmNumeroDocumento let-row let-rowIndex="rowIndex">
                            <!--<a href="/Layoult/Venta/{{row.DocEntry}}/{{ObjTypeDoc}}" target="_blank">{{row.DocNum}}</a>-->
                            <button class="btn btn-info btn-sm" (click)="abrirLayout(row)">{{row.DocNum}}</button>

                        </ng-template>
                        <ng-template #frmPago let-row let-rowIndex="rowIndex">
                            <button class="btn btn-primary btn-sm" (click)="abrirModalPagos(row)">
                                <i class="fas fa-credit-card me-1"></i>Pago
                            </button>
                        </ng-template>
                        <ng-template #frmEstado let-row let-rowIndex="rowIndex">
                            <span class="badge badge-primary" *ngIf="row.DocStatus=='O'">Abierta</span>
                            <span class="badge badge-danger" *ngIf="row.DocStatus=='C'">Cerrada</span>
                        </ng-template>
                        <ng-template #frmU_IND_EstadosNV let-row let-rowIndex="rowIndex">
                            <span class="badge bg-info" *ngIf="row.U_IND_EstadosNV=='1'">Recibido</span>
                            <span class="badge bg-warning" *ngIf="row.U_IND_EstadosNV=='2'">En preparación</span>
                            <span class="badge bg-success" *ngIf="row.U_IND_EstadosNV=='3'">Preparado</span>
                            
                        </ng-template>
                        <ng-template #frmVendedor let-row let-rowIndex="rowIndex">
                            {{this.vendedorCodigoATexto(row.SlpCode)}}
                        </ng-template>
                        <ng-template #frmFechaDocumento let-row let-rowIndex="rowIndex">
                            {{row.DocDate | date: 'dd/MM/yyyy'}}
                        </ng-template>
                        <ng-template #frmDocTotal let-row let-rowIndex="rowIndex">
                            <ng-container *ngIf="tipoSeguimiento === 'FAC' || tipoSeguimiento === 'BOL'; else totalDocNeto">
                                {{ row.DocTotalFC | iNDCLP }}
                            </ng-container>
                            <ng-template #totalDocNeto>
                                {{ row.DocTotal | iNDCLP }}
                            </ng-template>
                        </ng-template>
                                                <!-- Folio clickable que abre modal DTE (para boleta/factura) -->
                                                <ng-template #frmFolioClickable let-row let-rowIndex="rowIndex">
                                                    <button class="btn btn-link p-0 folio-link" (click)="abrirDteModal(row)" [disabled]="!getDTEUrl(row)" title="Ver DTE">
                                                        <span *ngIf="getDTEUrl(row); else noDte">{{row.FolioNum}}</span>
                                                        <ng-template #noDte><span class="text-muted">—</span></ng-template>
                                                    </button>
                                                </ng-template>
                        <ng-template #frmDTE let-row let-rowIndex="rowIndex">
                            <a *ngIf="getDTEUrl(row)"
                               class="btn btn-outline-secondary btn-sm"
                               [href]="getDTEUrl(row)" target="_blank" rel="noopener">
                                <i class="fas fa-file-pdf me-1"></i>DTE
                            </a>
                            <span *ngIf="!getDTEUrl(row)" class="text-muted">—</span>
                        </ng-template>
                        <ng-template #frmAccion let-row let-rowIndex="rowIndex">
                            <div class="input-group input-group-lg mb-3">
                                <div class="input-group-prepend dropright">
                                    <button type="button" class="btn btn-warning dropdown-toggle btn-sm"
                                        data-toggle="dropdown" aria-expanded="false"></button>
                                    <ul class="dropdown-menu" x-placement="right-start" *ngIf="tipoSeguimiento=='COT'">

                                        <li class="dropdown-item"> <a href="/Venta/23/{{row.DocEntry}}/NEW"
                                                class="form-control btn btn-warning"> Copiar</a></li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <a
                                                href="/Venta/23/{{row.DocEntry}}/17"
                                                class="form-control btn btn-warning"> Copiar a NV</a></li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <a
                                                href="/Venta/23/{{row.DocEntry}}" class="form-control btn btn-danger">
                                                Editar</a></li>
                                                <!--
                                                   <li class="dropdown-item"> <button (click)="EnviaCoreo(row)"
                                                class="form-control btn btn-success"> Enviar</button></li>
                                                -->
                                     
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <button
                                                (click)="CerrarDoc(row)" class="form-control btn btn-danger"> Cerrar
                                                cotización</button></li>
                                                <!--
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <button
                                                (click)="agregarOportunidad(row)" class="form-control btn btn-success">
                                                Generar NV</button></li>
                                        
                                        <li class="dropdown-item" *ngIf="!row.OpprId"> <button
                                                (click)="agregarOportunidad(row)" class="form-control btn btn-success">
                                                Agregar Oportunidad</button>
                                        </li>
                                        
                                        <li class="dropdown-item" *ngIf="row.OpprId">
                                            <a [routerLink]="'/Oportunidad/Detalle/'+row.OpprId">
                                                <button type="button" class="btn boton-crear" style="font-size: 16px;">
                                                    Abrir Oportunidad
                                                </button>
                                            </a>
                                        </li>
                                        -->
                                    </ul>

                                    <ul class="dropdown-menu" x-placement="left-start" *ngIf="tipoSeguimiento=='NV'">
                                        <li class="dropdown-item"><a href="/Venta/17/{{row.DocEntry}}/NEW"
                                                class="form-control btn btn-warning">Copiar</a></li>
                                        <li class="dropdown-item"><a href="/Venta/17/{{row.DocEntry}}"
                                                class="form-control btn btn-danger">Editar</a></li>
                                                <!--
                                                  <li class="dropdown-item"><button (click)="EnviaCoreo(row)"
                                                class="form-control btn btn-success">Enviar</button></li>
                                                -->
                                      
                                        <li class="dropdown-item"><button (click)="CerrarDoc(row)"
                                                class="form-control btn btn-danger">Cerrar nota de venta</button></li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <a
                                            href="/Venta/17/{{row.DocEntry}}/13"
                                            class="form-control btn btn-warning"> Copiar a Factura</a></li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <a
                                            href="/Venta/17/IB{{row.DocEntry}}/13"
                                            class="form-control btn btn-warning"> Copiar a Boleta</a></li>
                                        <!--
                                                
                                        <li class="dropdown-item" *ngIf="!row.OpprId"> <button
                                                (click)="agregarOportunidad(row)" class="form-control btn btn-success">
                                                Agregar Oportunidad</button>
                                        </li>
                                        
                                        <li class="dropdown-item" *ngIf="row.OpprId">
                                            <a [routerLink]="'/Oportunidad/Detalle/'+row.OpprId">
                                                <button type="button" class="btn boton-crear" style="font-size: 16px;">
                                                    Abrir Oportunidad
                                                </button>
                                            </a>
                                        </li>
                                        -->
                                    </ul>
                                    
                                    <ul class="dropdown-menu" x-placement="left-start" *ngIf="tipoSeguimiento=='SD'">
                                        <li class="dropdown-item"><a href="/Venta/234000031/{{row.DocEntry}}/NEW"
                                                class="form-control btn btn-warning">Copiar</a></li>
                                        <li class="dropdown-item"><a href="/Venta/234000031/{{row.DocEntry}}"
                                                class="form-control btn btn-danger">Editar</a></li>
                                                <!--
                                                <li class="dropdown-item"><button (click)="EnviaCoreo(row)"
                                                class="form-control btn btn-success">Enviar</button></li>
                                                -->
                                        
                                        <li class="dropdown-item"><button (click)="CerrarDoc(row)"
                                                class="form-control btn btn-danger">Cerrar Solicitud de Devolución</button>
                                        </li>
                                    </ul>

                                    <!-- Factura -->
                                    <ul class="dropdown-menu" x-placement="left-start" *ngIf="tipoSeguimiento=='FAC' || tipoSeguimiento == 'BOL'">
                                        <!--
                                        <li class="dropdown-item"><button (click)="EnviaCoreo(row)"
                                                class="form-control btn btn-success" target="_blank">Enviar</button>
                                        </li>
                                        -->
                                    </ul>
                                    <!--COMPRA-->
                                    <ul class="dropdown-menu" x-placement="left-start"
                                        *ngIf="tipoSeguimiento=='OFECOM'">
                                        <li class="dropdown-item"> <a href="/Compra/540000006/{{row.DocEntry}}/NEW"
                                                class="form-control btn btn-warning"> Copiar</a></li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <a
                                                href="/Compra/540000006/{{row.DocEntry}}/22"
                                                class="form-control btn btn-warning"> Copiar a pedido en transito</a>
                                        </li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <a
                                                href="/Compra/540000006/{{row.DocEntry}}"
                                                class="form-control btn btn-danger"> Editar</a></li>
                                                <!--
                                                <li class="dropdown-item"> <button (click)="EnviaCoreo(row)"
                                                class="form-control btn btn-success"> Enviar</button></li>
                                                -->
                                        
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <button
                                                (click)="CerrarDoc(row)" class="form-control btn btn-danger"> Cerrar
                                                pedido a fabrica</button></li>
                                        <li class="dropdown-item" [hidden]="row.DocStatus == 'C'"> <button
                                                (click)="generarOC(row)" class="form-control btn btn-success"> Generar
                                                pedido en transito</button></li>


                                    </ul>
                                    <ul class="dropdown-menu" x-placement="left-start"
                                        *ngIf="tipoSeguimiento=='COMPRA'">
                                        <li class="dropdown-item"><a href="/Compra/22/{{row.DocEntry}}/NEW"
                                                class="form-control btn btn-warning">Copiar</a></li>
                                        <li class="dropdown-item"><a href="/Compra/22/{{row.DocEntry}}"
                                                class="form-control btn btn-danger">Editar</a></li>
                                                <!--
                                                <li class="dropdown-item"><button (click)="EnviaCoreo(row)"
                                                class="form-control btn btn-success">Enviar</button></li>
                                                -->
                                        
                                        <li class="dropdown-item"><button (click)="CerrarDoc(row)"
                                            class="form-control btn btn-danger">Cerrar pedido en transito</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ng-template>

                    </div>
                </div>

                <!-- Controles de paginación -->
                <div class="row mt-3" *ngIf="totalPages > 1">
                    <div class="col-12 d-flex justify-content-center align-items-center">
                        <nav aria-label="Paginación">
                            <ul class="pagination pagination-sm mb-0">
                                <li class="page-item" [class.disabled]="currentPage === 1">
                                    <a class="page-link" href="javascript:void(0)" (click)="paginaAnterior()">‹</a>
                                </li>
                                <li class="page-item" *ngFor="let p of paginasVisibles" [class.active]="p === currentPage">
                                    <a class="page-link" href="javascript:void(0)" (click)="irAPagina(p)">{{p}}</a>
                                </li>
                                <li class="page-item" [class.disabled]="currentPage === totalPages">
                                    <a class="page-link" href="javascript:void(0)" (click)="paginaSiguiente()">›</a>
                                </li>
                            </ul>
                        </nav>
                        <span class="ms-3 text-muted small">Página {{currentPage}} de {{totalPages}}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<ng-template #modalPagos let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="fas fa-credit-card me-2"></i>
            Gestión de Pagos - Documento {{documentoSeleccionado?.DocNum}}
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <div class="modal-body">
        <!-- Spinner de carga -->
        <div *ngIf="cargandoPagos" class="text-center py-5">
            <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Cargando...</span>
            </div>
            <div class="text-muted">Cargando información de pagos...</div>
        </div>
        <!-- Información del documento (solo cuando NO se está creando el pago) -->
        <div class="row mb-4" *ngIf="!creandoPago && !cargandoPagos">
            <div class="col-md-4">
                <div class="info-card">
                    <small class="text-muted">Cliente:</small>
                    <div class="fw-bold">{{documentoSeleccionado?.CardName}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="info-card">
                    <small class="text-muted">Fecha Documento:</small>
                    <div class="fw-bold">{{documentoSeleccionado?.DocDate | date: 'dd/MM/yyyy'}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="info-card">
                    <small class="text-muted">Total Documento:</small>
                    <div class="fw-bold text-success">{{documentoSeleccionado?.DocTotalFC | iNDCLP}}</div>
                </div>
            </div>
        </div>

                <!-- Resumen financiero (si no está creando el pago, muestra botón para iniciar) -->
                <div class="row mb-4" *ngIf="!creandoPago && !cargandoPagos">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4">
                        <div class="summary-card bg-light p-3 rounded text-center">
                            <div class="text-muted">Total Pagado</div>
                            <div class="h5 text-success mb-0">{{totalPagado | iNDCLP}}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="summary-card bg-light p-3 rounded text-center">
                            <div class="text-muted">Total Pedido</div>
                            <div class="h5 text-primary mb-0">{{totalPedido | iNDCLP}}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="summary-card bg-light p-3 rounded text-center">
                            <div class="text-muted">Total Pendiente</div>
                            <div class="h5 text-warning mb-0">{{totalPendiente | iNDCLP}}</div>
                        </div>
                    </div>
                </div>
                        <div class="d-flex justify-content-end mt-3" *ngIf="!creandoPago">
                            <button type="button" class="btn btn-outline-primary" (click)="iniciarCreacionPago()">
                                <i class="fas fa-plus me-1"></i>Crear pago
                            </button>
                        </div>
            </div>
        </div>
        <!-- Tabs de métodos de pago (solo cuando se inicia creación) -->
        <div class="card" *ngIf="creandoPago && !cargandoPagos">
            <div class="card-header p-0">
                <ul class="nav nav-tabs" id="paymentTabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="cheque-tab" data-bs-toggle="tab" data-bs-target="#cheque" type="button" role="tab" aria-controls="cheque" aria-selected="true">
                            <i class="fas fa-money-check me-1"></i>Cheque
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="transferencia-tab" data-bs-toggle="tab" data-bs-target="#transferencia" type="button" role="tab" aria-controls="transferencia" aria-selected="false">
                            <i class="fas fa-exchange-alt me-1"></i>Transferencia Bancaria
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="tarjeta-tab" data-bs-toggle="tab" data-bs-target="#tarjeta" type="button" role="tab" aria-controls="tarjeta" aria-selected="false">
                            <i class="fas fa-credit-card me-1"></i>Tarjeta crédito/débito
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="efectivo-tab" data-bs-toggle="tab" data-bs-target="#efectivo" type="button" role="tab" aria-controls="efectivo" aria-selected="false">
                            <i class="fas fa-hand-holding-usd me-1"></i>Fondo en efectivo
                        </button>
                    </li>
                </ul>
            </div>
            
            <div class="card-body">
                <div class="tab-content" id="paymentTabsContent">
                    
                    <!-- TAB CHEQUE -->
                    <div class="tab-pane fade show active" id="cheque" role="tabpanel" aria-labelledby="cheque-tab">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">Fecha de vencimiento</label>
                                    <input [(ngModel)]="nuevoCheque.dueDate" type="date" class="form-control" placeholder="dd/mm/aaaa">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Banco</label>
                                    <div class="input-group input-group-sm nice-select">
                                        <span class="input-group-text bg-light"><i class="fas fa-university"></i></span>
                                        <select [(ngModel)]="nuevoCheque.bankTransfer" class="form-select">
                                            <option [ngValue]="''">Seleccione banco</option>
                                            <option *ngFor="let b of bancosCheques" [ngValue]="b.BankCode">{{ b.BankName }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label d-flex justify-content-between align-items-center">
                                        <span>Cuenta de mayor</span>
                                        <small class="text-muted ms-2">{{ chequeCuentaName }}</small>
                                    </label>
                                    <div class="input-group input-group-sm cuenta-mayor-group">
                                        <input [ngModel]="chequeCuentaLabel" class="form-control" readonly>
                                        <button type="button" class="btn btn-warning yellow-arrow" title="Ver cuenta (SAP)" (click)="abrirCuentaMayor('cheque')">
                                            <i class="fas fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">N° de cheque</label>
                                    <input [(ngModel)]="nuevoCheque.checkNum" type="text" class="form-control" placeholder="Número de cheque">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Endosado</label>
                                    <div class="input-group input-group-sm nice-select">
                                        <span class="input-group-text bg-light"><i class="fas fa-file-signature"></i></span>
                                        <select [(ngModel)]="nuevoCheque.endosado" class="form-select">
                                            <option [ngValue]="'SI'">Sí</option>
                                            <option [ngValue]="'NO'">No</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Importe</label>
                                    <input [(ngModel)]="nuevoCheque.ammount" type="number" class="form-control" placeholder="0">
                                </div>
                            </div>
                        </div>
                        
                        <!-- Tabla de cheques -->
                        <div class="table-responsive mt-4">
                            <table class="table table-sm table-striped">
                                <thead class="table-light">
                                    <tr>
                                        <th>Fecha de vencimiento</th>
                                        <th>Nombre del banco</th>
                                        <th>Cuenta</th>
                                        <th>N° de cheque</th>
                                        <th>Endoso</th>
                                        <th>Importe</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let c of cheques; let i = index">
                                        <td>{{c.dueDate | date: 'dd/MM/yyyy'}}</td>
                                        <td>{{c.bankTransfer}}</td>
                                        <td>{{c.account}}</td>
                                        <td>{{c.checkNum}}</td>
                                        <td>{{c.endosado}}</td>
                                        <td class="text-end">{{c.ammount | iNDCLP}}</td>
                                        <td>
                                            <button class="btn btn-outline-danger btn-sm" (click)="eliminarCheque(i)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr *ngIf="cheques.length === 0" class="text-center text-muted">
                                        <td colspan="7" class="py-3">
                                            <i class="fas fa-info-circle me-1"></i>
                                            No hay cheques registrados
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="d-flex justify-content-start mt-3">
                            <button type="button" class="btn btn-primary" (click)="agregarChequeDesdeUI()">
                                <i class="fas fa-plus me-1"></i>Agregar
                            </button>
                        </div>
                    </div>

                    <!-- TAB TRANSFERENCIA BANCARIA -->
                    <div class="tab-pane fade" id="transferencia" role="tabpanel" aria-labelledby="transferencia-tab">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">Cuenta bancaria</label>
                                    <select [(ngModel)]="transferenciaBancaria.account" class="form-select">
                                        <option [ngValue]="''">Seleccione una cuenta</option>
                                        <option *ngFor="let c of cuentasBanco" [ngValue]="c.CuentaContable">
                                            {{ c.NombreCuentaContable }}
                                        </option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Fecha de transferencias</label>
                                    <input [(ngModel)]="transferenciaBancaria.date" type="date" class="form-control" placeholder="dd/mm/aaaa">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">Refencia</label>
                                    <input [(ngModel)]="transferenciaBancaria.reference" type="text" class="form-control" placeholder="Referencia de la transferencia">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Total</label>
                                    <input [(ngModel)]="transferenciaBancaria.ammount" type="number" class="form-control" placeholder="0" value="0">
                                </div>
                            </div>
                        </div>
                        <!-- Posición del formulario principal (visible solo cuando hay cuenta seleccionada) -->
                        <div class="row" *ngIf="transferenciaBancaria.account && transferenciaBancaria.account !== ''">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="form-label">Posición del formulario principal</label>
                                    <select [(ngModel)]="transferenciaBancaria.cashFlowLineItemID" class="form-select">
                                        <option *ngFor="let p of posicionesFormulario" [ngValue]="p.CFWId">{{ p.CFWName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- TAB TARJETA CRÉDITO / DÉBITO -->
                    <div class="tab-pane fade" id="tarjeta" role="tabpanel" aria-labelledby="tarjeta-tab">
                        <div class="row">
                            <div class="col-md-6">
                                <!-- Primero: Selección de tipo de pago -->
                                <div class="mb-3">
                                    <label class="form-label">Tipo de pago</label>
                                    <select [(ngModel)]="nuevaTarjetaCredito.paymentMethod" (change)="onPaymentMethodChange()" class="form-select">
                                        <option [ngValue]="''">Seleccionar crédito o débito</option>
                                        <option [ngValue]="'1'">TARJETA CRÉDITO (1)</option>
                                        <option [ngValue]="'2'">TARJETA DÉBITO (2)</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label d-flex justify-content-between align-items-center">
                                        <span>Cuenta de mayor</span>
                                        <small class="text-muted ms-2">{{ tarjetaCuentaName }}</small>
                                    </label>
                                    <div class="input-group input-group-sm cuenta-mayor-group">
                                        <input [ngModel]="tarjetaCuentaLabel" class="form-control" readonly>
                                        <button type="button" class="btn btn-warning yellow-arrow" title="Ver cuenta (SAP)" (click)="abrirCuentaMayor('tarjeta')">
                                            <i class="fas fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Numero tarjeta</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.creditCardNumber" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="text" class="form-control" placeholder="Número de tarjeta">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Válido hasta</label>
                                    <input [ngModel]="nuevaTarjetaCredito.validUntil" type="date" class="form-control" placeholder="dd/mm/aaaa" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Numero de ID</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.ownerIDNumber" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="text" class="form-control" placeholder="ID">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Numero de teléfono</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.ownerPhone" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="tel" class="form-control" placeholder="Teléfono">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Tipo de transacción</label>
                                    <select [(ngModel)]="nuevaTarjetaCredito.transactionType" class="form-select" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                                        <option [ngValue]="'S'">Regular (S)</option>
                                        <option [ngValue]="'U'">Telefónica (U)</option>
                                        <option [ngValue]="'I'">Internet (I)</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Total a pagar</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.ammountDue" (change)="onChangeTarjetaCalculos()" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="0">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Cantidad de pagos</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.numerOfPayment" (change)="onChangeTarjetaCalculos()" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="1" min="1">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Primer pago parcial</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.firsAmmountPayment" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="0">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Cada pago adicional</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.eadAddAmmountPayment" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="0">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">N° Voucher</label>
                                    <input [(ngModel)]="nuevaTarjetaCredito.voucherNumebr" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="Número de voucher">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card border-secondary">
                                    <div class="card-header bg-light">
                                        <h6 class="mb-0">Certificados retención impuestos</h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="mb-3">
                                            <label class="form-label">N°</label>
                                            <select [(ngModel)]="nuevaTarjetaCredito.creditCard" class="form-select" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                                                <option [ngValue]="0">Seleccionar tarjeta</option>
                                                <!-- Reemplazar estos códigos por OCRC.CreditCard reales -->
                                                <option [ngValue]="1">VISA (1)</option>
                                                <option [ngValue]="2">MASTERCARD (2)</option>
                                            </select>
                                        </div>
                                        <div class="mb-3">
                                            <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="agregarTarjetaDesdeUI()" [disabled]="!nuevaTarjetaCredito.paymentMethod">Nuevo</button>
                                        </div>
                                        <!-- Lista compacta de tarjetas agregadas -->
                                        <div class="table-responsive mb-3" *ngIf="tarjetaCredito && tarjetaCredito.length">
                                            <table class="table table-sm table-bordered mb-0">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th style="width:56px">N°</th>
                                                        <th>TARJETAS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let t of tarjetaCredito; let i = index">
                                                        <td>{{t.Number}}</td>
                                                        <td>{{ t.paymentMethod === '1' ? 'TARJETA CRÉDITO' : 'TARJETA DÉBITO' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Teléfono para autorización</label>
                                            <input type="tel" class="form-control" placeholder="Teléfono" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">ID sociedad</label>
                                            <input type="text" class="form-control" placeholder="ID" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                                        </div>
                                    </div>
                                </div>
                                <!-- Total alineado a la derecha, sólo visual -->
                                <div class="mt-3 text-end">
                                    <label class="form-label me-2">Total</label>
                                    <input [ngModel]="nuevaTarjetaCredito.ammountDue" [disabled]="true" type="number" class="form-control d-inline-block" style="max-width: 160px;">
                                </div>
                            </div>
                            <!-- Se elimina la tabla inferior de tarjetas y el botón extra de agregar para simplificar la UI -->
                        </div>
                    </div>

                    <!-- TAB FONDO EN EFECTIVO -->
                    <div class="tab-pane fade" id="efectivo" role="tabpanel" aria-labelledby="efectivo-tab">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="form-label d-flex justify-content-between align-items-center">
                                        <span>Cuenta de mayor</span>
                                        <small class="text-muted ms-2">{{ efectivoCuentaName }}</small>
                                    </label>
                                    <div class="input-group input-group-sm cuenta-mayor-group">
                                        <input [ngModel]="efectivoCuentaLabel" class="form-control" readonly>
                                        <button type="button" class="btn btn-warning yellow-arrow" title="Ver cuenta (SAP)" (click)="abrirCuentaMayor('efectivo')">
                                            <i class="fas fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Monto</label>
                                    <input [(ngModel)]="efectivo.ammount" type="number" class="form-control" placeholder="0" value="0">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="d-flex justify-content-end gap-2 mt-3">
                    <button type="button" class="btn btn-secondary" (click)="cancelarCreacionPago()">Cancelar</button>
                    <button type="button" class="btn btn-success" (click)="enviarPagos()" [disabled]="(!hasTarjetaPendiente && tarjetaCredito.length===0 && cheques.length===0 && (!transferenciaBancaria?.ammount || transferenciaBancaria.ammount==0) && (!efectivo?.ammount || efectivo.ammount==0))">
                        <i class="fas fa-paper-plane me-1"></i>Enviar pago
                    </button>
                </div>
            </div>
        </div>
        <!-- Lista de pagos existentes (oculta cuando se crea un nuevo pago) -->
        <div class="mt-4" *ngIf="!creandoPago && !cargandoPagos">
            <h6>Pagos Registrados</h6>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-sm">
                    <thead class="bg-light">
                        <tr>
                            <th>N° Pago</th>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Referencia</th>
                            <th>Total</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let pago of listaPagos; let i = index" class="align-middle">
                            <td>
                                <span class="badge bg-primary">{{pago.numero || 'P-' + (i+1).toString().padStart(3, '0')}}</span>
                            </td>
                            <td>{{pago.fecha | date: 'dd/MM/yyyy'}}</td>
                            <td>
                                <span class="badge bg-info">{{pago.tipo || 'Cheque'}}</span>
                            </td>
                            <td>{{pago.referencia || pago.comentario || 'Sin referencia'}}</td>
                            <td class="text-end">
                                <span class="fw-bold text-success">{{pago.total | iNDCLP}}</span>
                            </td>
                            <td>
                                <span class="badge" 
                                      [ngClass]="{
                                        'bg-success': pago.estado === 'Pagado',
                                        'bg-warning': pago.estado === 'Pendiente',
                                        'bg-danger': pago.estado === 'Vencido'
                                      }">
                                    {{pago.estado}}
                                </span>
                            </td>
                            
                        </tr>
                        <tr *ngIf="listaPagos.length === 0">
                            <td colspan="7" class="text-center text-muted py-4">
                                <i class="fas fa-info-circle me-2"></i>
                                No se encontraron pagos registrados para este documento.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
    <div class="modal-footer bg-light" *ngIf="!creandoPago && !cargandoPagos">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
            <i class="fas fa-times me-1"></i>Cerrar
        </button>
    </div>
</ng-template>

<!-- Modal minimalista DTE -->
<ng-template #modalDTE let-modal>
    <div class="modal-header py-2 border-0">
        <h6 class="modal-title mb-0">
            <i class="fas fa-file-pdf text-danger me-2"></i>DTE Folio {{dteViewer.folio}}
        </h6>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="modal.dismiss()">&times;</button>
    </div>
    <div class="modal-body p-2 d-flex flex-column" style="height:75vh;">
        <div *ngIf="dteViewer.loading" class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-muted small">
            <div class="spinner-border spinner-border-sm mb-2" role="status"></div>
            Cargando DTE...
        </div>
        <iframe *ngIf="!dteViewer.loading" [src]="dteViewer.url | safeUrl" class="w-100 border-0 rounded shadow-sm flex-grow-1" style="background:#fafafa;"></iframe>
    </div>
    <div class="modal-footer py-2 border-0 justify-content-between">
        <div class="small text-muted">Si el PDF no carga, ver en pestaña nueva.</div>
        <a class="btn btn-sm btn-primary" *ngIf="dteViewer.url" [href]="dteViewer.url" target="_blank" rel="noopener">
            <i class="fas fa-external-link-alt me-1"></i>Abrir nueva pestaña
        </a>
    </div>
</ng-template>

<!-- Modal Cuenta de mayor (visual estilo SAP) -->
<ng-template #modalCuentaMayor let-modal>
    <div class="modal-header py-2 bg-warning text-dark">
        <h6 class="modal-title mb-0"><i class="fas fa-folder-open me-2"></i>Cuenta de mayor</h6>
        <button type="button" class="btn btn-sm btn-outline-dark" (click)="modal.dismiss()">&times;</button>
    </div>
    <div class="modal-body">
        <div class="mb-2 small text-muted">Visualización de cuenta asociada (no editable)</div>
        <div class="row g-3">
            <div class="col-12">
                <label class="form-label">Código (FatherNum)</label>
                <input class="form-control" [ngModel]="cuentaVistaActual?.fatherNum" readonly>
            </div>
            <div class="col-12">
                <label class="form-label">Nombre</label>
                <input class="form-control" [ngModel]="cuentaVistaActual?.acctName" readonly>
            </div>
            <div class="col-12">
                <label class="form-label">Cuenta interna (_SYS)</label>
                <input class="form-control" [ngModel]="cuentaVistaActual?.acctCode" readonly>
            </div>
        </div>
    </div>
    <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">Cerrar</button>
    </div>
</ng-template>